import { generateId } from "@@/utilities/generate-id";
import { z } from "zod";

import { idZodSchema } from "@@/shared/id";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import { quoteIdZodSchema } from "@@/shared/quotes/quote-id";

const createOrderFromQuoteCommandZodSchema = z.object({
    _id: idZodSchema,
    _type: z.literal("CREATE_ORDER_FROM_QUOTE_COMMAND"),
    quoteId: quoteIdZodSchema,
    providerId: providerIdZodSchema,
});
type CreateOrderFromQuoteCommand = z.infer<
    typeof createOrderFromQuoteCommandZodSchema
>;
const createOrderFromQuoteCommandFactoryParamsZodObject =
    createOrderFromQuoteCommandZodSchema.omit({
        _id: true,
        _type: true,
    });

type createOrderFromQuoteCommandFactoryParams = z.infer<
    typeof createOrderFromQuoteCommandFactoryParamsZodObject
>;
const createOrderFromQuoteCommandFactory = (
    params: createOrderFromQuoteCommandFactoryParams,
): CreateOrderFromQuoteCommand => {
    return {
        ...params,
        _id: generateId("CREATE_ORDER_FROM_QUOTE_COMMAND__"), // Or however you generate IDs
        _type: "CREATE_ORDER_FROM_QUOTE_COMMAND",
    };
};

export {
    createOrderFromQuoteCommandFactory,
    createOrderFromQuoteCommandFactoryParamsZodObject,
    createOrderFromQuoteCommandZodSchema,
};
export type {
    CreateOrderFromQuoteCommand,
    createOrderFromQuoteCommandFactoryParams,
};
